import { Checkbox } from '../../components/ui/checkbox';

export type ProductLite = { product_id: string; name: string };

interface Props {
  products: ProductLite[];
  selectedIds: ReadonlySet<string>;
  onToggle: (product: ProductLite) => void;
  disabled?: boolean;
}

/** The checkbox list inside the product assignment popover. */
export function ProductPickerList({ products, selectedIds, onToggle, disabled }: Props) {
  return (
    <>
      <div className="px-2 py-1 text-caption-medium uppercase tracking-wide text-muted-foreground">
        Assign products
      </div>
      {products.length === 0 ? (
        <div className="px-2 py-1.5 text-caption-regular text-muted-foreground">No products in this campaign</div>
      ) : (
        products.map((p) => (
          <label
            key={p.product_id}
            className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-body-sm-regular hover:bg-muted"
          >
            <Checkbox checked={selectedIds.has(p.product_id)} onCheckedChange={() => onToggle(p)} disabled={disabled} />
            {p.name}
          </label>
        ))
      )}
    </>
  );
}
